<div class="focus-knowledge-form">
  <div class="knowledge-form-header">
    <a rds-link standalone routerLink="/focus/my-offerings" class="mb-5">
      <rds-icon namespace="filled" icon="arrow_left" />
      {{ BUTTONS.BACK_TO_MY_OFFERINGS }}
    </a>

    @if (knowledgeUuid()) {
      <h2 class="ui-heading-3-bold">
        {{ KNOWLEDGE_FORM.HEADERS.EDIT }} {{ knowledge()?.knowledgeName }}
      </h2>
      <rds-badge
        size="s"
        type="minimal"
        color="blue"
        class="knowledge-badge"
        [label]="getContentStatusLabel(knowledgePublishedAt(), knowledgeUpdatedAt())">
      </rds-badge>
    }
  </div>

  <div class="knowledge-form-content">
    @if (showSkeleton()) {
    <inexp-form-skeleton />
    } @else {
    <form [formGroup]="formKnowledge" class="form">
      <!-- User instructions -->
      <fieldset class="form-box hidden" aria-labelledby="how-to-title">
        <h3 class="ui-heading-3-bold mb-5" id="how-to-title">
          {{ KNOWLEDGE_FORM.CONTENT.USER_INSTRUCTIONS.SECTION_TITLE }}
        </h3>
        <p class="ui-body-s-bold">
          {{ KNOWLEDGE_FORM.CONTENT.USER_INSTRUCTIONS.HINT }}
        </p>
        <rds-checkbox
          formControlName="userInstructionsVisible"
          name="userInstructionsVisible"
          [checked]="false"
          >{{
            KNOWLEDGE_FORM.CONTENT.USER_INSTRUCTIONS.CHECKBOX_LABEL
          }}</rds-checkbox
        >
        @if (formKnowledge.controls.userInstructionsVisible.value) {
          <div class="full-width-input">
              <rds-control-label>{{
                KNOWLEDGE_FORM.CONTENT.USER_INSTRUCTIONS.DESCRIPTION_LABEL
              }}</rds-control-label>
              <app-rich-text-editor
                formControlName="userInstructionLongDescription"
                [placeholder]="KNOWLEDGE_FORM.CONTENT.USER_INSTRUCTIONS.PLACEHOLDER"
                [readonly]="false"
                [minHeight]="120">
            </app-rich-text-editor>
            <div
              cdkDropList
              [cdkDropListData]="userInstructions.dataSource.data | orderByDisplay"
              (cdkDropListDropped)="dragDropUserInstruction($event)"
            >
              <table
                rds-table
                [dataSource]="userInstructions.dataSource"
                alternation="vertical"
              >
                <!-- Drag handle column -->
                <ng-container rdsColumnDef="publish">
                  <th class="publish-width" rds-header-cell *rdsHeaderCellDef>
                    {{
                      KNOWLEDGE_FORM.CONTENT.USER_INSTRUCTIONS.TABLE_COLUMNS
                        .STEP_PUBLISH
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element; let i = index">
                    <div
                      class="drag-checkbox-container"
                      cdkDrag
                      [cdkDragData]="element"
                    >
                      <span cdkDragHandle class="drag-handle">☰</span>
                      <rds-checkbox
                        class="drag-checkbox"
                        [checked]="element.published"
                        (change)="
                          toggleRowPublished(
                            element,
                            $event,
                            userInstructions,
                            'userInstructions'
                          )
                        "
                      >
                      </rds-checkbox>
                    </div>
                  </td>
                </ng-container>

                <!-- Title Column -->
                <ng-container rdsColumnDef="title">
                  <th rds-header-cell *rdsHeaderCellDef>
                    {{
                      KNOWLEDGE_FORM.CONTENT.USER_INSTRUCTIONS.TABLE_COLUMNS
                        .STEP_NAME
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    {{ element.title }}
                  </td>
                </ng-container>

                <!-- Description Column -->
                <ng-container rdsColumnDef="description">
                  <th rds-header-cell *rdsHeaderCellDef>
                    {{
                      KNOWLEDGE_FORM.CONTENT.USER_INSTRUCTIONS.TABLE_COLUMNS
                        .STEP_DESCRIPTION
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element" class="last-column table-description">
                    <span [innerHTML]="element.description | safeHtml"></span>
                    <div rdsDropdown class="options" autofocusFirstItem>
                      <button
                        rds-dropdown-toggle-icon-button
                        aria-label="More options"
                        type="button"
                      >
                        <rds-icon namespace="outlined" icon="more_vertical" />
                      </button>
                      <div *rdsDropdownMenu>
                        <ul rds-list-item-container>
                          <li>
                            <button
                              rds-list-item
                              (click)="handleUserInstructionDialog(element)"
                            >
                              {{ BUTTONS.EDIT }}
                            </button>
                          </li>
                          <li>
                            <button
                              rds-list-item
                              (click)="handleUserInstructionDelete(element)"
                            >
                              {{ BUTTONS.DELETE }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr
                  rds-header-row
                  *rdsHeaderRowDef="userInstructionColumns"
                ></tr>
                <tr
                  rds-row
                  *rdsRowDef="
                    let row;
                    columns: userInstructionColumns"
                ></tr>
              </table>
            </div>
          </div>
          <button
            rds-text-button
            (click)="handleUserInstructionDialog()"
            class="table-action"
          >
            <rds-icon icon="plus" namespace="filled" />
            {{ KNOWLEDGE_FORM.CONTENT.USER_INSTRUCTIONS.CTA }}
          </button>
        }
      </fieldset>
      <!-- Best practices -->
      <section class="form-box" aria-labelledby="best-practices-title">
        <h3 class="ui-heading-3-bold mb-5" id="best-practices-title">
          {{ KNOWLEDGE_FORM.CONTENT.BEST_PRACTICES.SECTION_TITLE }}
        </h3>
        <p class="ui-body-s-bold">
          {{ KNOWLEDGE_FORM.CONTENT.BEST_PRACTICES.HINT }}
        </p>
        <rds-checkbox
          formControlName="bestPracticesVisible"
          name="bestPracticesVisible"
          [checked]="false"
          >{{
            KNOWLEDGE_FORM.CONTENT.BEST_PRACTICES.CHECKBOX_LABEL
          }}</rds-checkbox
        >

        @if (formKnowledge.controls.bestPracticesVisible.value) {
          <div
            cdkDropList
            [cdkDropListData]="bestPractices.dataSource.data | orderByDisplay"
            (cdkDropListDropped)="dragDropBestPractice($event)"
          >
            <table
              rds-table
              [dataSource]="bestPractices.dataSource"
              alternation="vertical"
            >
              <!-- Drag handle column -->
              <ng-container rdsColumnDef="publish">
                <th class="publish-width" rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.BEST_PRACTICES.TABLE_COLUMNS.PUBLISH
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <div
                    class="drag-checkbox-container"
                    cdkDrag
                    [cdkDragData]="element"
                  >
                    <span cdkDragHandle class="drag-handle">☰</span>
                    <rds-checkbox
                      class="drag-checkbox"
                      [checked]="element.published"
                      (change)="
                        toggleRowPublished(
                          element,
                          $event,
                          this.bestPractices,
                          'bestPractices'
                        )
                      "
                    >
                    </rds-checkbox>
                  </div>
                </td>
              </ng-container>
              <ng-container rdsColumnDef="title">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.BEST_PRACTICES.TABLE_COLUMNS.TITLE
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.title }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.BEST_PRACTICES.TABLE_COLUMNS
                      .DESCRIPTION
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element" class="last-column">
                  <span [innerHTML]="element.description | safeHtml"></span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleBestPracticeDialog(element)"
                            tabindex="0"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleBestPracticeDelete(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="bestPracticeColumns"></tr>
              <tr
                rds-row
                *rdsRowDef="
                  let row;
                  columns: bestPracticeColumns"
              ></tr>
            </table>
          </div>
          <button
            rds-text-button
            (click)="handleBestPracticeDialog()"
            class="table-action"
          >
            <rds-icon icon="plus" namespace="filled" />
            {{ KNOWLEDGE_FORM.CONTENT.BEST_PRACTICES.CTA }}
          </button>
        }
      </section>
      <!-- Learning resources -->
      <section class="form-box" aria-labelledby="learning-resources-title">
        <h3 class="ui-heading-3-bold mb-5" id="learning-resources-title">
          {{ KNOWLEDGE_FORM.CONTENT.LEARNING_RESOURCES.SECTION_TITLE }}
        </h3>
        <p class="ui-body-s-bold">
          {{ KNOWLEDGE_FORM.CONTENT.LEARNING_RESOURCES.HINT }}
        </p>
        <rds-checkbox
          formControlName="learningResourcesVisible"
          name="learningResourcesVisible"
          [checked]="false"
          >{{
            KNOWLEDGE_FORM.CONTENT.LEARNING_RESOURCES.CHECKBOX_LABEL
          }}</rds-checkbox
        >

        @if (formKnowledge.controls.learningResourcesVisible.value) {
          <div
            cdkDropList
            [cdkDropListData]="learningResources.dataSource.data | orderByDisplay"
            (cdkDropListDropped)="dragDropLearningResources($event)"
          >
            <table
              rds-table
              [dataSource]="learningResources.dataSource"
              alternation="vertical"
            >
              <!-- Drag handle column -->
              <ng-container rdsColumnDef="publish">
                <th class="publish-width" rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.LEARNING_RESOURCES.TABLE_COLUMNS
                      .PUBLISH
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <div
                    class="drag-checkbox-container"
                    cdkDrag
                    [cdkDragData]="element"
                  >
                    <span cdkDragHandle class="drag-handle">☰</span>
                    <rds-checkbox
                      class="drag-checkbox"
                      [checked]="element.published"
                      (change)="
                        toggleRowPublished(
                          element,
                          $event,
                          this.learningResources,
                          'learningResources'
                        )
                      "
                    >
                    </rds-checkbox>
                  </div>
                </td>
              </ng-container>
              <ng-container rdsColumnDef="title">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.LEARNING_RESOURCES.TABLE_COLUMNS
                      .LINK_NAME
                  }}

                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.title }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="url">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.LEARNING_RESOURCES.TABLE_COLUMNS.LINK
                  }}

                </th>
                <td rds-cell *rdsCellDef="let element" class="last-column">
                  <span>{{ element.url }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleLearningResourceDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleLearningResourceDelete(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr
                rds-header-row
                *rdsHeaderRowDef="learningResourceColumns"
              ></tr>
              <tr
                rds-row
                *rdsRowDef="
                  let row;
                  columns: learningResourceColumns"
              ></tr>
            </table>
          </div>
          <button
            rds-text-button
            (click)="handleLearningResourceDialog()"
            class="table-action"
          >
            <rds-icon icon="plus" namespace="filled" />
            {{ KNOWLEDGE_FORM.CONTENT.LEARNING_RESOURCES.CTA }}
          </button>
        }
      </section>
      <!-- Technical resources -->
      <section class="form-box hidden" aria-labelledby="technical-resources-title">
        <h3 class="ui-heading-3-bold mb-5" id="technical-resources-title">
          {{ KNOWLEDGE_FORM.CONTENT.TECHNICAL_RESOURCES.SECTION_TITLE }}
        </h3>
        <p class="ui-body-s-bold">
          {{ KNOWLEDGE_FORM.CONTENT.TECHNICAL_RESOURCES.HINT }}
        </p>
        <rds-checkbox
          formControlName="technicalResourcesVisible"
          name="technicalResourcesVisible"
          [checked]="false"
          >{{
            KNOWLEDGE_FORM.CONTENT.TECHNICAL_RESOURCES.CHECKBOX_LABEL
          }}</rds-checkbox
        >

        @if (formKnowledge.controls.technicalResourcesVisible.value) {
          <div
            cdkDropList
            [cdkDropListData]="technicalResources.dataSource.data | orderByDisplay"
            (cdkDropListDropped)="dragDropTechnicalResources($event)"
          >
            <table
              rds-table
              [dataSource]="technicalResources.dataSource"
              alternation="vertical"
            >
              <!-- Drag handle column -->
              <ng-container rdsColumnDef="publish">
                <th class="publish-width" rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.TECHNICAL_RESOURCES.TABLE_COLUMNS
                      .PUBLISH
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <div
                    class="drag-checkbox-container"
                    cdkDrag
                    [cdkDragData]="element"
                  >
                    <span cdkDragHandle class="drag-handle">☰</span>
                    <rds-checkbox
                      class="drag-checkbox"
                      [checked]="element.published"
                      (change)="
                        toggleRowPublished(
                          element,
                          $event,
                          technicalResources,
                          'technicalResources'
                        )
                      "
                    >
                    </rds-checkbox>
                  </div>
                </td>
              </ng-container>
              <ng-container rdsColumnDef="title">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.TECHNICAL_RESOURCES.TABLE_COLUMNS
                      .LINK_NAME
                  }}

                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.title }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="url">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.TECHNICAL_RESOURCES.TABLE_COLUMNS
                      .LINK
                  }}

                </th>
                <td rds-cell *rdsCellDef="let element" class="last-column">
                  <span>{{ element.url }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleTechnicalResourceDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleTechnicalResourceDelete(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr
                rds-header-row
                *rdsHeaderRowDef="technicalResourceColumns"
              ></tr>
              <tr
                rds-row
                *rdsRowDef="
                  let row;
                  columns: technicalResourceColumns"
              ></tr>
            </table>
          </div>
          <button
            rds-text-button
            (click)="handleTechnicalResourceDialog()"
            class="table-action"
          >
            <rds-icon icon="plus" namespace="filled" />
            {{ KNOWLEDGE_FORM.CONTENT.TECHNICAL_RESOURCES.CTA }}
          </button>
        }
      </section>
      <!-- Integrations -->
      <fieldset class="form-box" aria-labelledby="integrations-title">
        <h3 class="ui-heading-3-bold mb-5" id="integrations-title">
          {{ KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.SECTION_TITLE }}
        </h3>
        <p class="ui-body-s-bold">
          {{ KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.HINT }}
        </p>
        <rds-checkbox
          formControlName="integrationsVisible"
          name="integrationsVisible"
          [checked]="false"
          >{{
            KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.CHECKBOX_LABEL
          }}</rds-checkbox
        >

        @if (formKnowledge.controls.integrationsVisible.value) {
          <div class="full-width-input">
              <rds-control-label>{{
                KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.OVERVIEW_LABEL
              }}</rds-control-label>
              <app-rich-text-editor
                formControlName="integrationLongDescription"
                [placeholder]="KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.OVERVIEW_PLACEHOLDER"
                [readonly]="false"
                [minHeight]="120">
            </app-rich-text-editor>
            <div
              cdkDropList
              [cdkDropListData]="integrations.dataSource.data | orderByDisplay"
              (cdkDropListDropped)="dragDropIntegrations($event)"
            >
              <table
                rds-table
                [dataSource]="integrations.dataSource"
                alternation="vertical"
              >
                <ng-container rdsColumnDef="publish">
                  <th class="publish-width" rds-header-cell *rdsHeaderCellDef>
                    {{
                      KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.TABLE_COLUMNS.PUBLISH
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    <div
                      class="drag-checkbox-container"
                      cdkDrag
                      [cdkDragData]="element"
                    >
                      <span cdkDragHandle class="drag-handle">☰</span>
                      <rds-checkbox
                        class="drag-checkbox"
                        [checked]="element.published"
                        (change)="
                          toggleRowPublished(
                            element,
                            $event,
                            integrations,
                            'integrations'
                          )
                        "
                      >
                      </rds-checkbox>
                    </div>
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="title">
                  <th rds-header-cell *rdsHeaderCellDef>
                    {{
                      KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.TABLE_COLUMNS.TITLE
                    }}

                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    <span>{{ element.title }}</span>
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="description">
                  <th rds-header-cell *rdsHeaderCellDef>
                    {{
                      KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.TABLE_COLUMNS
                        .DESCRIPTION
                    }}

                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    <span [innerHTML]="element.description | safeHtml"></span>
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="urlName">
                  <th rds-header-cell *rdsHeaderCellDef>
                    {{
                      KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.TABLE_COLUMNS
                        .LINK_NAME
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    <span>{{ element.urlName }}</span>
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="url">
                  <th rds-header-cell *rdsHeaderCellDef>
                    {{ KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.TABLE_COLUMNS.LINK }}
                  </th>
                  <td rds-cell *rdsCellDef="let element" class="last-column">
                    <span>{{ element.url }}</span>

                    <div rdsDropdown class="options" autofocusFirstItem>
                      <button
                        rds-dropdown-toggle-icon-button
                        aria-label="More options"
                        type="button"
                      >
                        <rds-icon namespace="outlined" icon="more_vertical" />
                      </button>
                      <div *rdsDropdownMenu>
                        <ul rds-list-item-container>
                          <li>
                            <button
                              rds-list-item
                              (click)="handleIntegrationDialog(element)"
                            >
                              {{ BUTTONS.EDIT }}
                            </button>
                          </li>
                          <li>
                            <button
                              rds-list-item
                              (click)="handleIntegrationDelete(element)"
                            >
                              {{ BUTTONS.DELETE }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr rds-header-row *rdsHeaderRowDef="integrationColumns"></tr>
                <tr
                  rds-row
                  *rdsRowDef="
                    let row;
                    columns: integrationColumns"
                ></tr>
              </table>
            </div>
          </div>
          <button
            rds-text-button
            (click)="handleIntegrationDialog()"
            class="table-action"
          >
            <rds-icon icon="plus" namespace="filled" />
            {{ KNOWLEDGE_FORM.CONTENT.INTEGRATIONS.CTA }}
          </button>
        }
      </fieldset>
      <!-- FAQ -->
      <section class="form-box" aria-labelledby="faq-title">
        <h3 class="ui-heading-3-bold mb-5" id="faq-title">
          {{ KNOWLEDGE_FORM.CONTENT.FAQ.SECTION_TITLE }}
        </h3>
        <p class="ui-body-s-bold">
          {{ KNOWLEDGE_FORM.CONTENT.FAQ.HINT }}
        </p>
        <rds-checkbox
          formControlName="faqVisible"
          name="faqVisible"
          [checked]="false"
          >{{ KNOWLEDGE_FORM.CONTENT.FAQ.CHECKBOX_LABEL }}</rds-checkbox
        >

        @if (formKnowledge.controls.faqVisible.value) {
          <div
            cdkDropList
            [cdkDropListData]="faq.dataSource.data | orderByDisplay"
            (cdkDropListDropped)="dragDropFaq($event)"
          >
            <table
              rds-table
              [dataSource]="faq.dataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="publish">
                <th class="publish-width" rds-header-cell *rdsHeaderCellDef>
                  {{ KNOWLEDGE_FORM.CONTENT.FAQ.TABLE_COLUMNS.PUBLISH }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <div
                    class="drag-checkbox-container"
                    cdkDrag
                    [cdkDragData]="element"
                  >
                    <span cdkDragHandle class="drag-handle">☰</span>
                    <rds-checkbox
                      class="drag-checkbox"
                      [checked]="element.published"
                      (change)="toggleRowPublished(element, $event, faq, 'faq')"
                    >
                    </rds-checkbox>
                  </div>
                </td>
              </ng-container>
              <ng-container rdsColumnDef="question">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{ KNOWLEDGE_FORM.CONTENT.FAQ.TABLE_COLUMNS.QUESTION }}
                </th>

                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.question }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="answer">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{ KNOWLEDGE_FORM.CONTENT.FAQ.TABLE_COLUMNS.ANSWER }}
                </th>

                <td rds-cell *rdsCellDef="let element" class="last-column">
                  <span>{{ element.answer }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleFaqDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleFaqDelete(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="faqColumns"></tr>
              <tr
                rds-row
                *rdsRowDef="let row; columns: faqColumns"
              ></tr>
            </table>
          </div>
          <button
            rds-text-button
            (click)="handleFaqDialog()"
            class="table-action"
          >
            <rds-icon icon="plus" namespace="filled" />
            {{ KNOWLEDGE_FORM.CONTENT.FAQ.CTA }}
          </button>
        }
      </section>
      <!-- Additional resources -->
      <section class="form-box hidden" aria-labelledby="additional-resources-title">
        <h3 class="ui-heading-3-bold mb-5" id="additional-resources-title">
          {{ KNOWLEDGE_FORM.CONTENT.ADDITIONAL_RESOURCES.SECTION_TITLE }}
        </h3>
        <p class="ui-body-s-bold">
          {{ KNOWLEDGE_FORM.CONTENT.ADDITIONAL_RESOURCES.HINT }}
        </p>
        <rds-checkbox
          formControlName="additionalResourcesVisible"
          name="additionalResourcesVisible"
          [checked]="false"
          >{{
            KNOWLEDGE_FORM.CONTENT.ADDITIONAL_RESOURCES.CHECKBOX_LABEL
          }}</rds-checkbox
        >

        @if (formKnowledge.controls.additionalResourcesVisible.value) {
          <div
            cdkDropList
            [cdkDropListData]="additionalResources.dataSource.data | orderByDisplay"
            (cdkDropListDropped)="dragDropAdditionalResources($event)"
          >
            <table
              rds-table
              [dataSource]="additionalResources.dataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="publish">
                <th class="publish-width" rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.ADDITIONAL_RESOURCES.TABLE_COLUMNS
                      .PUBLISH
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <div
                    class="drag-checkbox-container"
                    cdkDrag
                    [cdkDragData]="element"
                  >
                    <span cdkDragHandle class="drag-handle">☰</span>
                    <rds-checkbox
                      class="drag-checkbox"
                      [checked]="element.published"
                      (change)="
                        toggleRowPublished(
                          element,
                          $event,
                          this.additionalResources,
                          'additionalResources'
                        )
                      "
                    >
                    </rds-checkbox>
                  </div>
                </td>
              </ng-container>
              <ng-container rdsColumnDef="title">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.ADDITIONAL_RESOURCES.TABLE_COLUMNS
                      .LINK_NAME
                  }}

                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.title }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="url">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.ADDITIONAL_RESOURCES.TABLE_COLUMNS
                      .LINK
                  }}

                </th>
                <td rds-cell *rdsCellDef="let element" class="last-column">
                  <span>{{ element.url }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleAdditionalResourceDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleAdditionalResourceDelete(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr
                rds-header-row
                *rdsHeaderRowDef="additionalResourceColumns"
              ></tr>
              <tr
                rds-row
                *rdsRowDef="
                  let row;
                  columns: additionalResourceColumns"
              ></tr>
            </table>
          </div>
          <button
            rds-text-button
            (click)="handleAdditionalResourceDialog()"
            class="table-action"
          >
            <rds-icon icon="plus" namespace="filled" />
            {{ KNOWLEDGE_FORM.CONTENT.ADDITIONAL_RESOURCES.CTA }}
          </button>
        }
      </section>
      <!-- Success stories -->
      <section class="form-box hidden" aria-labelledby="success-stories-title">
        <h3 class="ui-heading-3-bold mb-5" id="success-stories-title">
          {{ KNOWLEDGE_FORM.CONTENT.SUCCESS_STORIES.SECTION_TITLE }}
        </h3>
        <p class="ui-body-s-bold">
          {{ KNOWLEDGE_FORM.CONTENT.SUCCESS_STORIES.HINT }}
        </p>
        <rds-checkbox
          formControlName="successStoriesVisible"
          name="successStoriesVisible"
          [checked]="false"
          >{{
            KNOWLEDGE_FORM.CONTENT.SUCCESS_STORIES.CHECKBOX_LABEL
          }}</rds-checkbox
        >

        @if (formKnowledge.controls.successStoriesVisible.value) {
          <div
            cdkDropList
            [cdkDropListData]="successStories.dataSource.data | orderByDisplay"
            (cdkDropListDropped)="dragDropSuccessStory($event)"
          >
            <table
              rds-table
              [dataSource]="successStories.dataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="publish">
                <th class="publish-width" rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.SUCCESS_STORIES.TABLE_COLUMNS.PUBLISH
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <div
                    class="drag-checkbox-container"
                    cdkDrag
                    [cdkDragData]="element"
                  >
                    <span cdkDragHandle class="drag-handle">☰</span>
                    <rds-checkbox
                      class="drag-checkbox"
                      [checked]="element.published"
                      (change)="
                        toggleRowPublished(
                          element,
                          $event,
                          successStories,
                          'successStories'
                        )
                      "
                    >
                    </rds-checkbox>
                  </div>
                </td>
              </ng-container>
              <ng-container rdsColumnDef="title">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.SUCCESS_STORIES.TABLE_COLUMNS.TITLE
                  }}

                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.title }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.SUCCESS_STORIES.TABLE_COLUMNS
                      .DESCRIPTION
                  }}

                </th>
                <td rds-cell *rdsCellDef="let element" class="last-column">
                  <span [innerHTML]="element.description | safeHtml"></span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleSuccessStoryDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleSuccessStoryDelete(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr rds-header-row *rdsHeaderRowDef="successStoryColumns"></tr>
              <tr
                rds-row
                *rdsRowDef="
                  let row;
                  columns: successStoryColumns"
              ></tr>
            </table>
          </div>
          <button
            rds-text-button
            (click)="handleSuccessStoryDialog()"
            class="table-action"
          >
            <rds-icon icon="plus" namespace="filled" />
            {{ KNOWLEDGE_FORM.CONTENT.SUCCESS_STORIES.CTA }}
          </button>
        }
      </section>
      <!-- Release notes -->
      <section class="form-box hidden" aria-labelledby="release-notes-title">
        <h3 class="ui-heading-3-bold mb-5" id="release-notes-title">
          {{ KNOWLEDGE_FORM.CONTENT.RELEASE_NOTES.SECTION_TITLE }}
        </h3>
        <p class="ui-body-s-bold">
          {{ KNOWLEDGE_FORM.CONTENT.RELEASE_NOTES.HINT }}
        </p>
        <rds-checkbox
          formControlName="releaseNotesVisible"
          name="releaseNotesVisible"
          [checked]="false"
          >{{
            KNOWLEDGE_FORM.CONTENT.RELEASE_NOTES.CHECKBOX_LABEL
          }}</rds-checkbox
        >

        @if (formKnowledge.controls.releaseNotesVisible.value) {
          <div
            cdkDropList
            [cdkDropListData]="releaseNotes.dataSource.data | orderByDisplay"
            (cdkDropListDropped)="dragDropReleaseNote($event)"
          >
            <table
              rds-table
              [dataSource]="releaseNotes.dataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="publish">
                <th class="publish-width" rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.RELEASE_NOTES.TABLE_COLUMNS.PUBLISH
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <div
                    class="drag-checkbox-container"
                    cdkDrag
                    [cdkDragData]="element"
                  >
                    <span cdkDragHandle class="drag-handle">☰</span>
                    <rds-checkbox
                      class="drag-checkbox"
                      [checked]="element.published"
                      (change)="
                        toggleRowPublished(
                          element,
                          $event,
                          this.releaseNotes,
                          'releaseNotes'
                        )
                      "
                    >
                    </rds-checkbox>
                  </div>
                </td>
              </ng-container>
              <ng-container rdsColumnDef="header">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{ KNOWLEDGE_FORM.CONTENT.RELEASE_NOTES.TABLE_COLUMNS.NAME }}

                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.header }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="subheader">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.RELEASE_NOTES.TABLE_COLUMNS.HEADER
                  }}

                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.subheader }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    KNOWLEDGE_FORM.CONTENT.RELEASE_NOTES.TABLE_COLUMNS
                      .DESCRIPTION
                  }}

                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span [innerHTML]="element.description | safeHtml"></span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="url">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{ KNOWLEDGE_FORM.CONTENT.RELEASE_NOTES.TABLE_COLUMNS.LINK }}

                </th>
                <td rds-cell *rdsCellDef="let element" class="last-column">
                  <span>{{ element.url }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleReleaseNoteDialog(element)"
                          >
                            Edit
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleReleaseNoteDelete(element)"
                          >
                            Delete
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="releaseNoteColumns"></tr>
              <tr
                rds-row
                *rdsRowDef="
                  let row;
                  columns: releaseNoteColumns"
              ></tr>
            </table>
          </div>
          <button
            rds-text-button
            (click)="handleReleaseNoteDialog()"
            class="table-action"
          >
            <rds-icon icon="plus" namespace="filled" />
            {{ KNOWLEDGE_FORM.CONTENT.RELEASE_NOTES.CTA }}
          </button>
        }
      </section>
    </form>
    <div class="form-actions">
      <button rds-secondary-button routerLink="/focus/my-offerings" size="l">
        {{ BUTTONS.CANCEL }}
      </button>
      <div class="draft-and-publish">
        <button
          rds-secondary-button
          (click)="handleDraftSave()"
          size="l"
          [disabled]="isDraftSaving() || isKnowledgeIdLoading()"
        >
          @if (isDraftSaving()) {
            <div class="loading-container">
              <rds-progress-spinner
                class="loading-spinner"
              ></rds-progress-spinner>
              {{ BUTTONS.DRAFT_SAVING }}
            </div>
          } @else {
            {{ BUTTONS.SAVE_DRAFT }}
          }
        </button>
        <button
          rds-primary-button
          (click)="handlePublish()"
          size="l"
          [disabled]="isPublishing() || isLoading() || isKnowledgeIdLoading()"
        >
          @if (isPublishing()) {
            <div class="loading-container">
              <rds-progress-spinner
                class="loading-spinner"
              ></rds-progress-spinner>
              {{ BUTTONS.PUBLISHING }}
            </div>
          } @else {
            {{ BUTTONS.PUBLISH }}
          }
        </button>
      </div>
    </div>
    }
  </div>
</div>
